<template>
  <div style="background: #fff;padding: 10px;margin-top: 10px;">
    <div>
      <div
        class="inner-title mb-3 mt-3"
        style="padding-top:20px; border-top:1px solid #ccc;font-weight:bold;font-size:18px;"
      >Re-KYC Details</div>
      <div class="row m-0 customerregform" v-if="isTechnical">
        <div class="col-12 col-md-6 col-lg-3">
          <div
            class="fieldhead"
            v-if="kycObj.idCardCode"
          >{{kycObj.idCardCode ==1 ? 'PAN Number:' : 'Company Registration Number'}}</div>
          <div class="fieldval">{{kycObj.idCardValue}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3">
          <div class="fieldhead">Partner Name</div>
          <div class="fieldval">{{kycObj.partnerName}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="kycObj.idCardDocId">
          <div class="fieldhead">PAN document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(kycObj.idCardDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(kycObj.idCardDocId)}}</a>
          </div>
        </div>
      </div>
      <div class="row m-0 customerregform" v-if="isTechnical">
        <div class="col-12 col-md-6 col-lg-3">
          <div class="fieldhead">Mobile number</div>
          <div class="fieldval">+{{kycObj.isdCode}}{{"-"}}{{kycObj.mobileNumber}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3">
          <div class="fieldhead">Email</div>
          <div class="fieldval">{{kycObj.email}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="kycObj.letterHeadDocId">
          <div class="fieldhead">Declaration Document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(kycObj.letterHeadDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(kycObj.letterHeadDocId)}}</a>
          </div>
        </div>
      </div>
      <hr />
      <div class="row m-0 customerregform" v-if="isTechnical">
        <div class="sub-head" style="width:100%">Address Details</div>
        <div class="col-12">
          <div
            class="fieldhead"
            v-if="kycObj.address"
          >{{kycObj.address.addressTypeCode==3 ? 'Registered Office Address':'Correspondence Address'}}</div>
          <table class="table table-striped mb-0">
            <thead>
              <tr class="oldbankheader th-left">
                <th>Street Address</th>
                <th>Country</th>
                <th>State</th>
                <th>City</th>
                <th>ZIP Code</th>
                <th>Attachment</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-if="kycObj.address">
                <td>{{kycObj.address.streetAddress}}</td>
                <td>{{kycObj.address.country}}</td>
                <td>{{kycObj.address.state}}</td>
                <td>{{kycObj.address.city}}</td>
                <td>{{kycObj.address.zipCode}}</td>
                <td>
                  <a
                    v-if="kycObj.address.documentId!=null"
                    @click="showFile(kycObj.address.documentId)"
                    href="#"
                  >{{getAttachmentName(kycObj.address.documentId)}}</a>
                  <span v-else>-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <hr />
      <div class="row m-0 customerregform" v-if="isFinancial && kycObj.idCardCode ==1">
        <div class="sub-head" style="width:100%">Statutory Details</div>
        <div class="col-12 col-md-6 col-lg-3" v-if="kycObj.statutory && kycObj.statutory.cin">
          <div class="fieldhead">CIN Number</div>
          <div class="fieldval">{{kycObj.statutory.cin}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="kycObj.cinDocId">
          <div class="fieldhead">GST document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(kycObj.cinDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(kycObj.cinDocId)}}</a>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="kycObj.statutory && kycObj.statutory.tanNumber">
          <div class="fieldhead">TAN Number</div>
          <div class="fieldval">{{kycObj.statutory.tanNumber}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="kycObj.tanDocId">
          <div class="fieldhead">TAN document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(kycObj.tanDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(kycObj.tanDocId)}}</a>
          </div>
        </div>
      </div>

      <hr v-if="kycObj.idCardCode ==1" />
      <!-- <div class="row m-0 customerregform" v-if="customerObj.countryCode != 100">
      <div class="sub-head" style="width:100%">Statutory Details</div>
      <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatNumber">
        <div class="fieldhead">VAT Number</div>
        <div class="fieldval">{{customerObj.vatNumber}}</div>
      </div>

      <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatDocumentId">
        <div class="fieldhead">VAT document</div>
        <div class="fieldval">
          <a
            @click="showAttachFile(customerObj.vatDocumentId)"
            href="#"
            class="mt-n2"
          >{{getFileName(customerObj.vatDocumentId)}}</a>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatDeclarationDocumentId">
        <div class="fieldhead">VAT Declaration</div>
        <div class="fieldval">
          <a
            @click="showAttachFile(customerObj.vatDeclarationDocumentId)"
            href="#"
            class="mt-n2"
          >{{getFileName(customerObj.vatDeclarationDocumentId)}}</a>
        </div>
      </div>
    </div>

      <hr v-if="customerObj.countryCode != 100" />-->

      <div class="row m-0 customerregform" v-if="isFinancial">
        <div class="sub-head" style="width:100%">Financial Details</div>
        <div class="col-12 col-md-6 col-lg-3">
          <div
            class="fieldhead"
            v-if="kycObj.financialDetails"
          >Last Financial Year Turn Over({{kycObj.financialDetails.financeYearDisplay?kycObj.financialDetails.financeYearDisplay:''}})</div>
          <div
            class="fieldval"
            v-if="kycObj.financialDetails"
          >{{kycObj.financialDetails.revenue?kycObj.financialDetails.revenue:'-'}}</div>
        </div>

        <div
          class="col-12 col-md-6 col-lg-3"
          v-if="kycObj.financialDetails && kycObj.financialDetails.financeDocId"
        >
          <div class="fieldhead">Balance Sheet</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(kycObj.financialDetails.financeDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(kycObj.financialDetails.financeDocId)}}</a>
          </div>
        </div>
      </div>

      <hr />

      <div class="sub-head" style="width:100%" v-if="isFinancial">Bank Details</div>
      <div class="card-background" v-if="isFinancial">
        <table class="table table-striped mb-0">
          <thead>
            <tr class="oldbankheader th-left">
              <th>Account Category</th>
              <th>Account Number</th>
              <th>Payment in favour of</th>
              <th>Account Type</th>
              <th>Payment Mode</th>
              <th>Bank Name</th>
              <th v-if="kycObj.idCardCode ==1">IFSC Code</th>
              <th v-if="kycObj.idCardCode !=1">Swift Code</th>
              <th v-if="kycObj.idCardCode !=1">IBAN Number</th>
              <th>Attachment</th>
              <th>Payment Ref Email</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-if="kycObj.bankDetails">
              <td>{{kycObj.bankDetails.accountCategory}}</td>
              <td>{{kycObj.bankDetails.accountNumber}}</td>
              <td>{{kycObj.bankDetails.paymentInfavourOf}}</td>
              <td>{{kycObj.bankDetails.accountType}}</td>
              <td>{{kycObj.bankDetails.paymentMode}}</td>
              <td>{{kycObj.bankDetails.bankName}}</td>
              <td v-if="kycObj.idCardCode ==1">{{kycObj.bankDetails.ifscCode}}</td>
              <td v-if="kycObj.idCardCode !=1">{{kycObj.bankDetails.swiftBicCode}}</td>
              <td v-if="kycObj.idCardCode !=1">{{kycObj.bankDetails.ibanNumber}}</td>
              <td>
                <a
                  v-if="kycObj.bankDetails.documentId!=null"
                  @click="showFile(kycObj.bankDetails.documentId)"
                  href="#"
                >{{getAttachmentName(kycObj.bankDetails.documentId)}}</a>
                <span v-else>-</span>
              </td>
              <td>{{kycObj.bankDetails.paymentRefMailId}}</td>
            </tr>
          </tbody>
        </table>
        {{kycObj.bankDetails && kycObj.bankDetails.length==0 ? 'No Bank details' : ''}}
      </div>
    </div>
    <div>
      <div
        class="inner-title mb-3 mt-3"
        style="padding-top:20px; border-top:1px solid #ccc;font-weight:bold;font-size:18px;"
      >Existing Details</div>
      <div class="row m-0 customerregform" v-if="isTechnical">
        <div class="col-12 col-md-6 col-lg-3">
          <div
            class="fieldhead"
          >{{existingKycObj.idCardCode ==1 ? 'PAN Number:' : 'Company Registration Number'}}</div>
          <div class="fieldval">{{existingKycObj.idCardValue}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3">
          <div class="fieldhead">Partner Name</div>
          <div class="fieldval">{{existingKycObj.partnerName}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="existingKycObj.idCardDocId">
          <div class="fieldhead">PAN document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(existingKycObj.idCardDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(existingKycObj.idCardDocId)}}</a>
          </div>
        </div>
      </div>
      <div class="row m-0 customerregform" v-if="isTechnical">
        <div class="col-12 col-md-6 col-lg-3">
          <div class="fieldhead">Mobile number</div>
          <div class="fieldval">+{{existingKycObj.isdCode}}{{"-"}}{{existingKycObj.mobileNumber}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3">
          <div class="fieldhead">Email</div>
          <div class="fieldval">{{existingKycObj.email}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="existingKycObj.letterHeadDocId">
          <div class="fieldhead">Declaration Document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(existingKycObj.letterHeadDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(existingKycObj.letterHeadDocId)}}</a>
          </div>
        </div>
      </div>
      <hr />
      <div class="row m-0 customerregform" v-if="isTechnical">
        <div class="sub-head" style="width:100%">Address Details</div>
        <div class="col-12">
          <div
            class="fieldhead"
          >{{existingKycObj.address.addressTypeCode==3 ? 'Registered Office Address':'Correspondence Address'}}</div>
          <table class="table table-striped mb-0">
            <thead>
              <tr class="oldbankheader th-left">
                <th>Street Address</th>
                <th>Country</th>
                <th>State</th>
                <th>City</th>
                <th>ZIP Code</th>
                <th>Attachment</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-if="existingKycObj.address">
                <td>{{existingKycObj.address.streetAddress}}</td>
                <td>{{existingKycObj.address.country}}</td>
                <td>{{existingKycObj.address.state}}</td>
                <td>{{existingKycObj.address.city}}</td>
                <td>{{existingKycObj.address.zipCode}}</td>
                <td>
                  <a
                    v-if="existingKycObj.address.documentId!=null"
                    @click="showFile(existingKycObj.address.documentId)"
                    href="#"
                  >{{getAttachmentName(existingKycObj.address.documentId)}}</a>
                  <span v-else>-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 col-md-6 col-lg-3" v-if="existingKycObj.address.documentId">
          <div class="fieldhead">Address proof Document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(existingKycObj.address.documentId)"
              href="#"
              class="mt-n2"
            >{{getFileName(existingKycObj.address.documentId)}}</a>
          </div>
        </div>
      </div>

      <hr />
      <div class="row m-0 customerregform" v-if="isFinancial && existingKycObj.idCardCode ==1">
        <div class="sub-head" style="width:100%">Statutory Details</div>
        <div class="col-12 col-md-6 col-lg-3" v-if="existingKycObj.statutory.cin">
          <div class="fieldhead">CIN Number</div>
          <div class="fieldval">{{existingKycObj.statutory.cin}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="existingKycObj.cinDocId">
          <div class="fieldhead">GST document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(existingKycObj.cinDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(existingKycObj.cinDocId)}}</a>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="existingKycObj.statutory.tanNumber">
          <div class="fieldhead">TAN Number</div>
          <div class="fieldval">{{existingKycObj.statutory.tanNumber}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="existingKycObj.tanDocId">
          <div class="fieldhead">TAN document</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(existingKycObj.tanDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(existingKycObj.tanDocId)}}</a>
          </div>
        </div>
      </div>

      <hr v-if="existingKycObj.idCardCode ==1" />
      <!-- <div class="row m-0 customerregform" v-if="customerObj.countryCode != 100">
      <div class="sub-head" style="width:100%">Statutory Details</div>
      <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatNumber">
        <div class="fieldhead">VAT Number</div>
        <div class="fieldval">{{customerObj.vatNumber}}</div>
      </div>

      <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatDocumentId">
        <div class="fieldhead">VAT document</div>
        <div class="fieldval">
          <a
            @click="showAttachFile(customerObj.vatDocumentId)"
            href="#"
            class="mt-n2"
          >{{getFileName(customerObj.vatDocumentId)}}</a>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-3" v-if="customerObj.vatDeclarationDocumentId">
        <div class="fieldhead">VAT Declaration</div>
        <div class="fieldval">
          <a
            @click="showAttachFile(customerObj.vatDeclarationDocumentId)"
            href="#"
            class="mt-n2"
          >{{getFileName(customerObj.vatDeclarationDocumentId)}}</a>
        </div>
      </div>
    </div>

      <hr v-if="customerObj.countryCode != 100" />-->

      <div class="row m-0 customerregform" v-if="isFinancial">
        <div class="sub-head" style="width:100%">Financial Details</div>
        <div class="col-12 col-md-6 col-lg-3">
          <div
            class="fieldhead"
          >Last Financial Year Turn Over({{existingKycObj.financialDetails.financeYearDisplay?existingKycObj.financialDetails.financeYearDisplay:''}})</div>
          <div
            class="fieldval"
          >{{existingKycObj.financialDetails.revenue?existingKycObj.financialDetails.revenue:'-'}}</div>
        </div>

        <div class="col-12 col-md-6 col-lg-3" v-if="existingKycObj.financialDetails.financeDocId">
          <div class="fieldhead">Balance Sheet</div>
          <div class="fieldval">
            <a
              @click="showAttachFile(existingKycObj.financialDetails.financeDocId)"
              href="#"
              class="mt-n2"
            >{{getFileName(existingKycObj.financialDetails.financeDocId)}}</a>
          </div>
        </div>
      </div>

      <hr />

      <div class="sub-head" style="width:100%" v-if="isFinancial">Bank Details</div>
      <div class="card-background" v-if="isFinancial">
        <table class="table table-striped mb-0">
          <thead>
            <tr class="oldbankheader th-left">
              <th>Account Category</th>
              <th>Account Number</th>
              <th>Payment in favour of</th>
              <th>Account Type</th>
              <th>Payment Mode</th>
              <th>Bank Name</th>
              <th v-if="existingKycObj.idCardCode ==1">IFSC Code</th>
              <th v-if="existingKycObj.idCardCode !=1">Swift Code</th>
              <th v-if="existingKycObj.idCardCode !=1">IBAN Number</th>
              <th>Attachment</th>
              <th>Payment Ref Email</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr>
              <td>{{existingKycObj.bankDetails.accountCategory}}</td>
              <td>{{existingKycObj.bankDetails.accountNumber}}</td>
              <td>{{existingKycObj.bankDetails.paymentInfavourOf}}</td>
              <td>{{existingKycObj.bankDetails.accountType}}</td>
              <td>{{existingKycObj.bankDetails.paymentMode}}</td>
              <td>{{existingKycObj.bankDetails.bankName}}</td>
              <td v-if="existingKycObj.idCardCode ==1">{{existingKycObj.bankDetails.ifscCode}}</td>
              <td v-if="existingKycObj.idCardCode !=1">{{existingKycObj.bankDetails.swiftBicCode}}</td>
              <td v-if="existingKycObj.idCardCode !=1">{{existingKycObj.bankDetails.ibanNumber}}</td>
              <td>
                <a
                  v-if="existingKycObj.bankDetails.documentId!=null"
                  @click="showFile(existingKycObj.bankDetails.documentId)"
                  href="#"
                >{{getAttachmentName(existingKycObj.bankDetails.documentId)}}</a>
                <span v-else>-</span>
              </td>
              <td>{{existingKycObj.bankDetails.paymentRefMailId}}</td>
            </tr>
          </tbody>
        </table>
        {{existingKycObj.bankDetails.length==0 ? 'No Bank details' : ''}}
      </div>
    </div>
    <hr />
    <w-loading-spinner :loadSpinner="loading" />
  </div>
</template>

<script>
import { SummaryServices } from "../../services/summaryService";
const SummaryService = new SummaryServices();

import { OnBoardingServices } from "../../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
import { PartnerService } from "../../services/partnerService";
const partnerService = new PartnerService();
import moment from "moment";
import LoadingSpinner from "../../widgets/LoadingSpinner";
import TextInput from "../../widgets/TextInput.vue";
import DropDown from "../../widgets/DropDown";
import Datepicker from "../../widgets/DatePicker";
import DatePicker from "vue2-datepicker";
import partnertable from "../../widgets/partner-table-collapsable";
export default {
  props: ["answerNumber", "country", "partnerId", "companyCode"],
  components: {
    "w-text-input": TextInput,
    "w-drop-down": DropDown,
    "w-datepicker": Datepicker,
    "w-collapse-table": partnertable,
    "w-loading-spinner": LoadingSpinner,
    DatePicker
  },
  data() {
    return {
      isTechnical: false,
      isFinancial: false,
      loading: false,
      enableSubmit: true,
      kycObj: {},
      existingKycObj: {},
      documentNumber: "KYC2201T2000001"
    };
  },
  watch: {},
  created() {
    this.getKycData();
    this.getKYCExistingDetails();
    this.getDocument();
  },
  computed: {},
  methods: {
    getDocument() {
      if (this.answerNumber.substring(7, 8) == "T") {
        this.isTechnical = true;
      }
      if (this.answerNumber.substring(7, 8) == "F") {
        this.isFinancial = true;
      }
    },
    getKYCExistingDetails() {
      partnerService
        .getKycDetails(this.companyCode, this.partnerId)
        .then(resp => {
          this.existingKycObj = resp.response;
        });
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    },
    getFileName(fileName) {
      if (fileName != null) {
        var fileNameFinal = null;
        fileNameFinal = fileName.split(/_(.+)/)[1];
        return fileNameFinal;
      }
      return fileNameFinal;
    },
    getKycData() {
      SummaryService.getKycDetails(this.answerNumber)
        .then(resp => {
          this.loading = false;
          if (resp.failureMessage != "") {
            window.alert(resp.failureMessage);
          } else {
            this.kycObj = resp.response;
          }
        })
        .catch(error => {
          console.log(error);
          window.alert(error);
          if (error.failureMessage != "") {
            window.alert(error.failureMessage);
          } else {
            window.alert("something went wrong!");
          }
        });
    },
    getAttachmentName(documentId) {
      if (documentId) {
        let attachmentName = "";
        attachmentName = documentId.split(/_(.+)/)[1]
          ? documentId.split(/_(.+)/)[1]
          : documentId;
        return attachmentName;
      }
    },
    dateFormat(date) {
      return moment(date).format("Do MMMM YYYY");
    },
    showFile(event) {
      this.loading = true;
      SummaryService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.fieldhead {
  text-align: left;
  font-weight: bold;
}
.sub-head {
  text-align: left;
  font-weight: bold;
  font-size: 14px;
}
.headingss {
  text-align: left;
  font-weight: bold;
  font-size: 16px;
}
.fieldval {
  text-align: left;
}
.oldbankheader th {
  background: #949494;
}
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.table-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
}
.header-Text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
}
</style>

<style>
.table thead th {
  font-size: 15px !important;
  font-family: "Source Sans Pro", sans-serif;
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
}
</style>